import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    titleTable: {
      marginTop: "4rem",
      marginBottom: "2rem"
    },
    rootTable: {
      overflowX: "auto",
      width: "100%",
      border: `1px solid ${theme.palette.grey[300]}`,
      borderBottom: 0,
      borderRadius: "2px",
      "& .MuiTableCell-head": {
        "& *": {
          color: theme.palette.grey[900]
        }
      },
      "& .MuiTableBody-root": {
        "& .MuiTableCell-root": {
          padding: "1.2rem 1.2rem ",
          borderTop: `1px solid ${theme.palette.grey[300]}`,
          borderRight: `1px solid ${theme.palette.grey[300]}`
        }
      },
      "& .MuiTableHead-root": {
        "& .MuiTableCell-root": {
          padding: "2.8rem 1.2rem ",
          borderTop: `1px solid ${theme.palette.grey[300]}`,
          borderRight: `1px solid ${theme.palette.grey[300]}`
        }
      },
      "&::-webkit-scrollbar": {
        height: "14px",
        background: "#FFFFFF"
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        height: "6px"
      }
    },
    tabBox: {
      display: "flex",
      marginTop: "24px"
    },
    zMax: {
      zIndex: 100
    },
    tabB: {
      marginLeft: "-3rem"
    },
    tableTabActive: {
      background: theme.palette.info.dark
    },
    tableTabInactive: {
      background: theme.palette.grey[400]
    },
    innerTabActive: {
      WebkitClipPath: "polygon(0 0, 77.5% 0, 99% 100%, 0% 100%)",
      clipPath: "polygon(0 0, 77.5% 0, 99% 100%, 0% 100%)",
      width: "199px",
      height: "39px",
      boxShadow: "2px 0px 4px rgba(0, 0, 0, 0.25)",
      borderTopLeftRadius: "5px",
      display: "flex",
      alignItems: "center",
      paddingLeft: "2.4rem",
      cursor: "pointer",
      top: 1,
      left: 1,
      background: theme.palette.info.main,
      position: "absolute",
      borderBottom: 0,
      color: "#FFFFFF"
    },
    tableTab: {
      WebkitClipPath: "polygon(0 0, 78% 0, 100% 100%, 0% 100%)",
      clipPath: "polygon(0 0, 78% 0, 100% 100%, 0% 100%)",
      width: "200px",
      height: "40px",
      boxShadow: "2px 0px 4px rgba(0, 0, 0, 0.25)",
      borderTopLeftRadius: "6px",
      display: "flex",
      alignItems: "center",
      paddingLeft: "2.4rem",
      cursor: "pointer",
      position: "relative",
      justifyContent: "start",
      border: 0
    },
    tableContainer: {
      maxHeight: "60vh"
    },
    innerTab: {
      WebkitClipPath: "polygon(0 0, 77.5% 0, 99% 100%, 0% 100%)",
      clipPath: "polygon(0 0, 77.5% 0, 99% 100%, 0% 100%)",
      width: "199px",
      height: "39px",
      boxShadow: "2px 0px 4px rgba(0, 0, 0, 0.25)",
      borderTopLeftRadius: "5px",
      display: "flex",
      alignItems: "center",
      paddingLeft: "2.4rem",
      cursor: "pointer",
      top: 1,
      left: 1,
      background: theme.palette.grey[300],
      color: theme.palette.grey[600],
      position: "absolute",
      borderBottom: 0
    },
    col_1a: {
      minWidth: 370,
      maxWidth: 370,
      width: 370
    },
    col_1c: {
      minWidth: 310,
      width: 310
    },
    col_2a: {
      minWidth: 160
    },
    col_3a: {
      minWidth: 140
    },
    col_4a: {
      minWidth: 140
    },
    col_5a: {
      minWidth: 110
    },
    col_6a: {
      minWidth: 135
    },
    col_7a: {
      minWidth: 290
    },
    col_8a: {
      minWidth: 140
    },
    col_9a: {
      minWidth: 180
    },
    col_10a: {
      minWidth: 140
    },
    col_2b: {
      minWidth: 110,
      maxWidth: 110
    },
    col_3b: {
      minWidth: 180,
      maxWidth: 180
    },
    col_4b: {
      minWidth: 620,
      maxWidth: 620
    },
    freeze_1: {
      position: "sticky",
      left: 0,
      background: "inherit",
      zIndex: 3
    },
    emptyBox: {
      height: 170,
      padding: "2.4rem 2.6rem",
      background: "#FFF",
      border: `solid 1px ${theme.palette.grey[300]}`
    },
    infoEmpty: {
      display: "flex",
      alignItems: "center"
    },
    icon: {
      marginRight: "1.1rem"
    },
    textInfo: {
      color: theme.palette.grey[700]
    },
    boxContainer: {
      padding: "2.4rem",
      background: "#FFF"
    },
    rowMatName: {
      display: "flex",
      alignItems: "center"
    },
    matName: {
      color: theme.palette.info.main
    },
    boldText: {
      fontWeight: 700
    },
    summaryAs: {
      marginLeft: "auto",
      color: theme.palette.grey[600]
    },
    rowTotal: {
      display: "flex",
      alignItems: "center",
      gap: 20,
      margin: "2rem 0 4rem 0"
    },
    plantSelect: {
      display: "flex",
      alignItems: "center",
      marginLeft: "auto",
      gap: 20,
      "& .MuiFormControl-root": {
        width: 200,
        height: 32
      }
    },
    noBorder: {
      border: 0,
      background: "inherit"
    },
    zIndex1: {
      zIndex: 1
    }
  }),
  { name: "StockOnHandResult" }
);

export default useStyles;
